export const cyldMixin = {
  data() {
    return {
      rightPath: "cyldDrawer" // tip: 产业亮点的右则固定名称
    };
  },
  methods: {
    // 共用的显示右则内容
    showRightDt(data, rightCname = "zypDrawer") {
      // 缓存rightcomponent
      sessionStorage.setItem("rightComponent", this.rightPath);
      setTimeout(() => {
        this.$store.dispatch("drawer/setGraphic", data);
        this.$store.dispatch("drawer/setRightComponent", rightCname);
      }, 10);
    }
  }
};
